"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.width = void 0;
const layout_1 = require("@carbon/layout");
exports.width = {
    layersPanel: (0, layout_1.rem)(360),
    keyframeInspectorPanel: (0, layout_1.rem)(300),
};
